import { render, staticRenderFns } from "./category-item.vue?vue&type=template&id=18b17138&scoped=true&"
import script from "./category-item.vue?vue&type=script&lang=js&"
export * from "./category-item.vue?vue&type=script&lang=js&"
function injectStyles (context) {
  
  
}

/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "18b17138",
  null
  ,true
)

export default component.exports